
































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import * as routes from "@/employer/route-names";
import { FundingOption, Permission } from "@/shared/types";
import { useUserStore } from "@/shared/store/user";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component
export default class SettingsNavigation extends Vue {
  userStore = useUserStore();
  rolePermissionsStore = useRolePermissionsStore();
  featureFlagStore = useFeatureFlagStore();


  routes = routes;
  activeTab = null;

  mounted (): void {
    this.activeTab = this.$route.name;
  }

  navigationClicked (pathName: string) {
    this.activeTab = pathName;
    this.$emit("navigation-tab-item-clicked", {
      name: this.$route.name,
      path: pathName
    });
  }

  get showSecurity (): boolean {
    return true;
  }

  get fundingOption (): FundingOption {
    if (this.userStore.currentEmployer && this.userStore.currentEmployer.fundingOption) {
      return this.userStore.currentEmployer.fundingOption;
    }

    return FundingOption.None;
  }

  get hasPayrollWritePermission (): boolean {
    return this.rolePermissionsStore.userHasPermission(Permission.PayrollWrite);
  }

}

